import { Button, Modal, ParagraphText } from '@opallabs/lapidary'
import * as styles from './styles'
import { AddMomentToBoardModalProps, MomentToBoardState } from './types'

type AddToBoardFooterProps = Pick<
  AddMomentToBoardModalProps,
  'onAddToBoard' | 'onCloseModal'
> &
  Pick<
    MomentToBoardState,
    | 'boardSelectionChanged'
    | 'hasError'
    | 'initialSelection'
    | 'isLoading'
    | 'moments'
    | 'selectedBoards'
    | 'unschedule'
  > & { invalidIdCount: number; momentCount: number }

export const saveButtonText = 'Update'

export const AddToBoardFooter: React.FC<AddToBoardFooterProps> = ({
  boardSelectionChanged,
  hasError,
  initialSelection,
  invalidIdCount,
  isLoading,
  moments,
  momentCount,
  onAddToBoard,
  onCloseModal,
  selectedBoards,
  unschedule,
}) => {
  const disableSave = () => {
    if (isLoading) return true
    if (!initialSelection.length && !selectedBoards?.added.length) return true
    if (hasError) return true
    if (!unschedule && !boardSelectionChanged()) return true

    return false
  }

  return (
    <Modal.Footer css={styles.footer}>
      <span css={styles.selectionText}>
        {momentCount > 1 && (
          <ParagraphText css={styles.selectionText}>
            {momentCount} items selected
          </ParagraphText>
        )}
      </span>
      <span css={styles.footerButtons}>
        <Button
          buttonText="Cancel"
          className="cancel-add"
          name="Cancel add to board"
          onClick={() => onCloseModal()}
          variant="ghost"
        />
        <Button
          buttonText={saveButtonText}
          className="add-to-board"
          disabled={disableSave()}
          name="Add to board"
          onClick={() =>
            onAddToBoard?.({
              boardSelectionChanged,
              invalidIdCount,
              moments,
              onCloseModal,
              selectedBoards,
              unschedule,
            })
          }
          variant="primary"
        />
      </span>
    </Modal.Footer>
  )
}
